import { isNumber } from 'lodash-es';

import { cn } from '../cn';
import { Editor, General } from '../StrokeIcons';
import Tooltip from '../Input2/Tooltip';

export type FieldIconProps = {
  source: string;
  confidenceScore?: number | null;
  className?: string;
};

export function FieldIcon({ confidenceScore, source, className }: FieldIconProps) {
  let type: string | null = null;
  let label: string | null = null;

  if (source.startsWith('enhance') || source.startsWith('enrich')) {
    type = 'enhance';
    label = 'source: enhance';
  } else if (source === 'linkedin-api') {
    type = 'linkedIn';
    label = 'source: linkedin api';
  } else if (source === 'linkedin-electron') {
    type = 'linkedIn';
    label = 'source: linkedin electron';
  } else if (source.startsWith('linkedin')) {
    type = 'linkedIn';
    label = 'source: linkedin';
  } else if (source.startsWith('crm') || source.startsWith('input')) {
    type = 'inputed';
    label = 'source: inputed';
  } else if (source.startsWith('csv')) {
    type = 'csv';
    label = 'source: csv';
  } else if (source.startsWith('basic-enhance') || source.startsWith('basic-enrich')) {
    type = 'basic-enhance';
    label = confidenceScore
      ? `Probable email with a confidence score of ${
          isNumber(confidenceScore) ? confidenceScore.toFixed(2) : confidenceScore
        }%`
      : 'source: basic enhance';
  } else if (source.startsWith('ai')) {
    type = 'ai';
    label = 'source: AI';
  }

  if (type === null) return null;

  return (
    <Tooltip tooltip={label}>
      <div className={cn('size-3.5 self-center [&>svg]:size-full shrink-0', className)}>
        {type === 'enhance' && <Editor.Wand />}
        {type === 'linkedIn' && <General.StepMessage />}
        {type === 'inputed' && <Editor.TextInput />}
        {type === 'csv' && <General.UploadCloud02 />}
        {type === 'basic-enhance' && <General.SearchRefraction />}
        {type === 'ai' && <Editor.Wand />}
      </div>
    </Tooltip>
  );
}
